import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountFormComponent } from '../account-form/account-form.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements AfterViewInit {

  @ViewChild("table", { static: false }) table: TableComponent;

  public company_uuid;
  public filterMonth;
  public months:any = []
  public type = "all"
  public is_mario:boolean = false;
  public permission:any = {};
  public configuration:any = {};
  public is_loading:boolean = false;
  public unclaims = [];
  constructor(private http: HttpService, private ngbModel: NgbModal) {
    
    this.company_uuid = this.http.getStaticSelectedCompany();
    let today = new Date();
    let lm = (new Date());
    lm.setMonth(today.getMonth() - 1)
    this.filterMonth = today.getFullYear() + "-" + ("0" + (today.getMonth() + 1)).slice(-2);

    // this.months = [{
    //     value: today.getFullYear() + "-" + ("0" + (today.getMonth() + 1)).slice(-2),
    //     label: ("0" + (today.getMonth() + 1)).slice(-2) + "-" + today.getFullYear()
    //   },
    //   {
    //     value: lm.getFullYear() + "-" + ("0" + (lm.getMonth() + 1)).slice(-2),
    //     label: ("0" + (lm.getMonth() + 1)).slice(-2) + "-" + lm.getFullYear()
    //   }
    // ]

    // Generate the past 10 months including this month in the `months` array
    this.months = [];
    for(let i = 0; i < 12; i++) {
      let d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      let value = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2);
      let label = ("0" + (d.getMonth() + 1)).slice(-2) + "-" + d.getFullYear();
      this.months.push({ value, label });
    }
    this.filterMonth = today.getFullYear() + "-" + ("0" + (today.getMonth() + 1)).slice(-2);

    this.getConfiguration();
  }

  ngAfterViewInit(): void {

    (async () => {

      await this.initPermission();
      this.init();
      this.table.reloadEvent.subscribe((v:any) => {
        this.init();
      })

      this.table.dataEvent.subscribe((v:any) => {
        let unclaims = v.filter((a:any) => {
          return !a.claim
        })

        let create_by = unclaims.map((v:any) => {
          return v.create_by_title;
        })

        let unique = [...new Set(create_by)]
        this.unclaims = []
        for(var x = 0; x < unique.length; x++) {
          console.log(unclaims.filter((a:any) => {
            return a.create_by_title == unique[x];
          }))
          let total = unclaims.filter((a:any) => {
            return a.create_by_title == unique[x];
          }).reduce( function(a, b){
            return parseFloat(a) + parseFloat(b['credit'] ?? 0);
          }, 0);
          this.unclaims.push({create_by: unique[x], total})
        }

      })

    })();

    
  }

  monthChange() {
    this.init();
  }

  async initPermission() {
    this.permission = await this.http.getHiddenPermission();
  }

  async init() {
    const setting:any = 
        { post: {url: "/admin/account/get", data: {monthyear: this.filterMonth, type: this.type}},
          disabled_pagenat: false,
          show_sum: true,
          fields: [
            {label: '', type: 'checkbox'}, 
            {label: 'No', type: 'index'}, 
            {label: 'Ledger Date', type: 'date', key: 'date'}, 
            {label: 'Title', type: 'string', key: 'title'}, 
            {label: 'Debit 进', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true}, 
            {label: 'Credit 出', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true}, 
            {label: 'Create By', type: 'string', key: 'create_by_title', deduct: ['debit', 'credit']}
          ]}
        
          if(this.permission['expenses-admin']) {
            setting.fields.push({label: 'Copy', type: 'copy'})
            setting.fields.push({label: 'Edit', type: 'link', key: 'uuid', "link": '/lo/' + this.company_uuid + '/account/form', hide: true})
            setting.fields.push({label: 'Claim/Unclaim', type: 'claim', key: "claim"})
          }

          this.table.init(setting);
        
  }

  switchLedger(type) {
    this.type = type;
    this.init();
  }

  async paste() {
    this.is_loading = true;

    let y:any = await this.http.post("/admin/copy/get", {filterMonth: this.filterMonth});
    this.init();

    this.is_loading = false;

    // if(y.data) {
    //   let date = y.data.date.split("T")
    //   let data:any = {debit: y.data.debit, credit: y.data.credit, title: y.data.title, date: date[0]};

    //   if(y.data.debit) {
    //     data.type = "debit"
    //     data.amount = y.data.debit
    //   } else {
    //     data.type = "credit"
    //     data.amount = y.data.credit
    //   }

    //   let modal = this.ngbModel.open(AccountFormComponent);
    //   modal.componentInstance.setData = data;

    //   modal.componentInstance.closeEvent.subscribe(() => {
    //     modal.close();
    //     this.init();
    //   })

    // }
  }

  async copy() {

    this.is_loading = true;
    let data = this.table.checkedValue()

    if(data.length == 0) {
      this.is_loading = false;
      alert("Failed to Copy data. Please select data to copy!")

      return;
    }
    
    await this.http.post("/admin/copy", {data: data});
    this.is_loading = false;

    alert("Data Copied!")
    
  }

  public async getConfiguration() {
    let rtn:any = await this.http.post("/admin/company/setting");
    this.configuration = rtn.setting;
  }
}
